import dayjs from "dayjs";

//import AdditionalInfoForm from "./AdditionalInfoForm";
//import ForeignField from "./ForeignField";
import { isNaN } from "formik";
import ForeignField from "./ForeignField";
import { useTranslation } from "react-i18next";
import AditionalInfoForm from "./AdditionalInfoForm";
import moment from "moment/moment";
import HtmlEditor from "./HtmlEditor";
import JsonEdit from "./JsonEdit";


const RecursiveContainer = ({ config, formik, prefix, isFilter, sended }) => {

  const { t } = useTranslation();

  const handleDateChange = (fieldName, newValue) => {
    try {
      formik.setFieldValue(fieldName, newValue.target.value);
    } catch (err) {
      console.error('error con la fecha', newValue, err)
    }
  };

  const handleBoolChange = (fieldName) => {
    try {
      formik.setFieldValue(fieldName, (!formik.values[fieldName] || formik.values[fieldName] === 0) ? 1 : 0);
    } catch (err) {

    }
  };

  const handleJsonCheckedsChange = (fieldName, option) => {
    try {
      var values = formik.values[fieldName] || "[]";
      values = JSON.parse(values);

      if (values.includes(option)) {
        values = values.filter((r) => r !== option);
      } else {
        values.push(option);
      }

      formik.setFieldValue(fieldName, JSON.stringify(values));
    } catch (err) {
      console.error(err);
    }
  };

  const handleSelChange = (fieldName, event) => {
    try {
      formik.setFieldValue(fieldName, event.target.value);
    } catch (err) {

    }
  };

  const handleDecimalChange = (fieldName, newValue) => {
    try {
      if (!isNaN(newValue.target.value)) {
        console.log('is not nan', fieldName, parseFloat(newValue.target.value));

        formik.setFieldValue(fieldName, newValue.target.value);
      } else {
        console.log('is not numeric', newValue);
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleNumberChange = (fieldName, evt) => {
    try {
      if (!isNaN(evt.target.value))
        formik.setFieldValue(fieldName, parseInt(evt.target.value));
    } catch (err) {

    }
  }

  const handleNumberValidate = (iConfig, evt) => {
    try {
      if (iConfig.minValue) {
        if (evt.target.value < iConfig.minValue) {
          evt.target.value = iConfig.minValue
        }
      }
      if (iConfig.maxValue) {
        if (evt.target.value > iConfig.maxValue) {
          evt.target.value = iConfig.maxValue
        }
      }
    } catch (err) {

    }
  }

  const handleHtmlChange = (fieldName, value) => {
    formik.setFieldValue(fieldName, value);
  }

  const builder = (individualConfig, prefix) => {

    if (individualConfig.dbname === 'additional_info') {
      return (
        <AditionalInfoForm
          key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}
          config={individualConfig}
          formik={formik}
          prefix={prefix}
          isFilter={isFilter}
          sended={sended}
          color="tertiary"
        />
      )
    } else if (individualConfig.foreign) {
      return (
        <ForeignField
          color="tertiary"
          key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}
          config={individualConfig}
          formik={formik}
          prefix={prefix}
          isFilter={isFilter}
          sended={sended}
        />
      )
    } else /* if (individualConfig.options) {
      return (
        <div className={classes.filterField} key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}>
          <label className={classes.filterFieldLabel} htmlFor={individualConfig.dbname}>{tr(individualConfig.label)}</label>
          <Select
            color="tertiary"
            variant="standard"
            id={individualConfig.dbname}
            label={tr(individualConfig.label)}
            value={(formik.values && formik.values[individualConfig.dbname]) || ""}
            onChange={(event) => { handleSelChange(individualConfig.dbname, event) }}
          >
            <MenuItem value={null}>choose</MenuItem>
            {
              individualConfig.options.map((x) => (
                <MenuItem key={`filter_${individualConfig.dbname}_${x.value}`} value={x.value}>{x.label}</MenuItem>
              ))
            }
          </Select>
        </div>
      )
    } else  */ {
      switch (individualConfig.type) {
        case 'text':
          return (
            <div className="mb-3 row" key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}>

              <label htmlFor={`${isFilter ? "ffilter" : "fform"}_${prefix}_${individualConfig.dbname}`} className="col-md-3 col-form-label">{t(individualConfig.label)}</label>
              <div className="col-md-9">
                <textarea
                  color="tertiary"
                  type="text"
                  id={`${isFilter ? "ffilter" : "fform"}_${prefix}_${individualConfig.dbname}`}
                  value={(formik.values && formik.values[individualConfig.dbname]) || ''}
                  onChange={formik.handleChange}
                  name={individualConfig.dbname}
                  multiline={(individualConfig.type === 'text').toString()}
                  className="form-control"
                  placeholder={individualConfig.label}
                  rows="3"
                />

                {
                  sended && formik.errors && formik.errors[individualConfig.dbname] &&
                  <div className="form-text alert-danger">
                    {formik.errors[individualConfig.dbname]}
                  </div>
                }

                {
                  individualConfig.htmlEditor && <HtmlEditor
                    prefix={prefix}
                    name={individualConfig.dbname}
                    onchange={handleHtmlChange}
                    currValue={(formik.values && formik.values[individualConfig.dbname]) || ''}
                  />
                }

              </div>
            </div>
          );
        case 'string':
          return (
            <div className="mb-3 row" key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}>

              <label htmlFor={`${isFilter ? "ffilter" : "fform"}_${prefix}_${individualConfig.dbname}`} className="col-md-3 col-form-label">{t(individualConfig.label)}</label>
              <div className="col-md-9">
                <input
                  color="tertiary"
                  type="text"
                  id={`${isFilter ? "ffilter" : "fform"}_${prefix}_${individualConfig.dbname}`}
                  value={(formik.values && formik.values[individualConfig.dbname]) || ''}
                  onChange={formik.handleChange}
                  name={individualConfig.dbname}
                  multiline={(individualConfig.type === 'text').toString()}
                  className="form-control"
                  placeholder={individualConfig.label}
                />
                {
                  sended && formik.errors && formik.errors[individualConfig.dbname] &&
                  <div className="form-text alert-danger">
                    {formik.errors[individualConfig.dbname]}
                  </div>
                }
              </div>
            </div>
          );
        case 'password':
          return (
            <div className="mb-3 row" key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}>

              <label htmlFor={`${isFilter ? "ffilter" : "fform"}_${prefix}_${individualConfig.dbname}`} className="col-md-3 col-form-label">{t(individualConfig.label)}</label>
              <div className="col-md-9">
                <input
                  color="tertiary"
                  type="password"
                  id={`${isFilter ? "ffilter" : "fform"}_${prefix}_${individualConfig.dbname}`}
                  value={(formik.values && formik.values[individualConfig.dbname]) || ''}
                  onChange={formik.handleChange}
                  name={individualConfig.dbname}
                  multiline={(individualConfig.type === 'text').toString()}
                  className="form-control"
                  placeholder={individualConfig.label}
                />
                {
                  sended && formik.errors && formik.errors[individualConfig.dbname] &&
                  <div className="form-text alert-danger">
                    {formik.errors[individualConfig.dbname]}
                  </div>
                }
              </div>
            </div>
          );
        /* case 'password':
          return (
            <div className={classes.filterField} key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}>
              <TextField
                color="tertiary"
                type={"password"}
                id={`${isFilter ? "ffilter" : "fform"}_${prefix}_${individualConfig.dbname}`}
                label={tr(individualConfig.label)}
                variant="standard"
                value={(formik.values && formik.values[individualConfig.dbname]) || ''}
                sx={{ width: 300 }}
                //error={(sended && formik.errors && formik.errors[individualConfig.dbname] != undefined)}
                onChange={formik.handleChange}
                name={individualConfig.dbname}
                helperText={
                  sended && formik.errors && formik.errors[individualConfig.dbname] ?
                    formik.errors[individualConfig.dbname]
                    : ''
                }
              />
            </div>
          ); */
        case 'mail':
          return (
            <div className="row" key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}>
              <label htmlFor={`${isFilter ? "ffilter" : "fform"}_${prefix}_${individualConfig.dbname}`} className="col-md-3 col-form-label">{t(individualConfig.label)}</label>
              <div className="col-md-9">
                <input
                  color="tertiary"
                  type="mail"
                  id={`${isFilter ? "ffilter" : "fform"}_${prefix}_${individualConfig.dbname}`}
                  value={(formik.values && formik.values[individualConfig.dbname]) || ''}
                  onChange={formik.handleChange}
                  name={individualConfig.dbname}
                  multiline={(individualConfig.type === 'text').toString()}
                  className="form-control"
                  placeholder={individualConfig.label}
                />
                {
                  sended && formik.errors && formik.errors[individualConfig.dbname] &&
                  <div className="form-text alert-danger">
                    {formik.errors[individualConfig.dbname]}
                  </div>
                }
              </div>
            </div>
          );
        case 'number':
          return (
            <div className="mb-3 row" key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}>
              <label htmlFor={`${isFilter ? "ffilter" : "fform"}_${prefix}_${individualConfig.dbname}`} className="col-md-3 col-form-label">{t(individualConfig.label)}</label>
              <div className="col-md-9">
                <input
                  color="tertiary"
                  type="number"
                  id={`${isFilter ? "ffilter" : "fform"}_${prefix}_${individualConfig.dbname}`}
                  value={(formik.values && formik.values[individualConfig.dbname]) || ''}
                  onChange={(evt) => { handleNumberChange(individualConfig.dbname, evt) }}
                  onBlur={(evt) => { handleNumberValidate(individualConfig, evt) }}
                  name={individualConfig.dbname}
                  multiline={(individualConfig.type === 'text').toString()}
                  className="form-control"
                  placeholder={individualConfig.label}
                />
                {
                  sended && formik.errors && formik.errors[individualConfig.dbname] &&
                  <div className="form-text alert-danger">
                    {formik.errors[individualConfig.dbname]}
                  </div>
                }
              </div>
            </div>
          )
        case 'decimal':
          return (
            <div className="row" key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}>
              <div className="col mb-3">
                <label htmlFor={`${isFilter ? "ffilter" : "fform"}_${prefix}_${individualConfig.dbname}`} className="form-label">{t(individualConfig.label)}</label>
                <input
                  color="tertiary"
                  type="number"
                  id={`${isFilter ? "ffilter" : "fform"}_${prefix}_${individualConfig.dbname}`}
                  value={(formik.values && formik.values[individualConfig.dbname]) || ''}
                  onChange={(evt) => { handleDecimalChange(individualConfig.dbname, evt) }}
                  name={individualConfig.dbname}
                  multiline={(individualConfig.type === 'text').toString()}
                  className="form-control"
                  placeholder={individualConfig.label}
                />
                {
                  sended && formik.errors && formik.errors[individualConfig.dbname] &&
                  <div className="form-text alert-danger">
                    {formik.errors[individualConfig.dbname]}
                  </div>
                }
              </div>
            </div>
          )
        case 'datetime':
          return (
            <div className="mb-3 row" key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}>
              <label htmlFor={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`} className="col-md-3 col-form-label">{t(individualConfig.label)}</label>
              <div className="col-md-9">
                <input
                  className="form-control"
                  type="datetime-local"
                  id={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}
                  defaultValue={dayjs((formik.values && formik.values[individualConfig.dbname]) || '')}
                  onChange={(value) => { handleDateChange(individualConfig.dbname, value) }}
                />
              </div>
            </div>
          )
        case 'date':
          return (
            <div className="mb-3 row" key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}>
              <label htmlFor={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`} className="col-md-3 col-form-label">{t(individualConfig.label)}</label>
              <div className="col-md-9">
                <input
                  className="form-control"
                  type="date"
                  id={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}
                  value={((formik.values && formik.values[individualConfig.dbname]?.split('T')[0]) || '')}
                  onChange={(value) => { handleDateChange(individualConfig.dbname, value) }}
                />
              </div>
            </div>
          )
        case 'boolean':
          return (
            <>
              {!isFilter &&
                <div className="form-check" key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    onChange={() => { handleBoolChange(individualConfig.dbname) }}
                    checked={(formik.values && formik.values[individualConfig.dbname] === 1) || false}
                    name={individualConfig.dbname}
                    id={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}

                  /><label className="form-check-label" htmlFor={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}> {t(individualConfig.label)} </label>
                </div>
              }
              {
                isFilter &&
                <div className="mb-3" key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}>
                  <label htmlFor={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`} className="form-label">{t(individualConfig.label)}</label>
                  <select className="form-select" id={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`} aria-label="Default select example">
                    <option >Choose</option>
                    <option value="0">False</option>
                    <option value="1">True</option>
                  </select>
                </div>
              }
            </>
          );
        case 'json':
          console.log('el tipo es json');

          return (
            <div className="mb-3 row" key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}>
              <label htmlFor={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`} className="col-md-3 col-form-label">{t(individualConfig.label)}</label>
              <div className="col-md-9">
                <JsonEdit value={(formik.values && formik.values[individualConfig.dbname]) || ''} />
              </div>
            </div>
          )
        /* case 'json':
          return (
            <div className={classes.filterField} key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}>
              <label className={classes.filterFieldLabel} htmlFor={individualConfig.dbname}>{tr(individualConfig.label)}</label>
              {!isFilter && individualConfig.show?.type === 'checkbox' &&
                individualConfig.show?.values.map((chk) => (
                  <div key={`${individualConfig.dbname}_${chk}`}><label className={classes.filterFieldLabel} htmlFor={`${individualConfig.dbname}_${chk}`}>{tr(chk)}</label>
                    <input type='checkbox'
                      className={classes.filterFieldInput}
                      name={`${individualConfig.dbname}_${chk}`}
                      onChange={() => { handleJsonCheckedsChange(individualConfig.dbname, chk) }}
                      checked={(formik.values && formik.values[individualConfig.dbname]?.includes(chk)) || false}
                    />
                  </div>
                ))

              }
              {
                isFilter &&
                <Select
                  color="tertiary"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Age"
                  value={(formik.values && formik.values[individualConfig.dbname]) || ""}
                  onChange={(event) => { handleSelChange(individualConfig.dbname, event) }}
                >
                  <MenuItem value={null}>choose</MenuItem>
                  <MenuItem value={'0'}>False</MenuItem>
                  <MenuItem value={1}>True</MenuItem>
                </Select>
              }
            </div>
          ) */
        default:
          return <div key={`${isFilter ? "filter" : "form"}_${prefix}_${individualConfig.dbname}`}>Pending for {individualConfig.type}</div>
      }
    }
  }

  return (
    <div key={`${isFilter ? "filter" : "form"}_${prefix}`}>
      {config?.map((c) => {
        if ((isFilter && c.filter) || (!isFilter && c.form))
          return builder(c, prefix);
        return "";
      })}
    </div>
  );
};

export default RecursiveContainer;